import { GameIcon } from '@/components/GameIcon';
import type { Game } from '@/constants/game.const';
import { cn } from '@/utils/cn';
import { formatMatchTime } from '@/utils/matches';

const TimeDisplay = ({ beginAt }: { beginAt?: string }) => {
  return <span className="whitespace-nowrap">{formatMatchTime(beginAt)}</span>;
};

interface MatchBannerProps {
  game: Game | null;
  status: string;
  beginAt?: string;
}

export const MatchBanner = ({ game, status, beginAt }: MatchBannerProps) => {
  return (
    <div className="flex flex-col items-center justify-center gap-1 rounded-lg bg-card-bg p-2">
      <GameIcon game={game} />
      <div
        className={cn(
          status === 'finished' ? 'opacity-50' : '',
          'font-medium text-[11px] text-gray leading-[14px]'
        )}
      >
        {status === 'finished' ? 'Finished' : <TimeDisplay beginAt={beginAt} />}
      </div>
    </div>
  );
};
